import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

export const getPickemGameRulesVersions = (type?: string) =>
  apiClient.get('/api/admin/pickems/game-rules', { params: { type } });

export const useGetPickemGameRulesVersionsQuery = (type?: string) => {
  return useQuery({
    queryKey: ['pickem-game-rules', 'versions', type],
    queryFn: () => getPickemGameRulesVersions(type),
  });
};
